import { isOtaPlanActive } from '@/api/ota/helpers';
import { OtaPlanDetails } from '@/api/ota/types';
import { useDeviceOtaDetail } from '@/api/ota/useDeviceOtaDetail';
import { useSpotterContext } from '@/context/SpotterContext';
import { useIsSharedDevice } from '@/hooks/useIsSharedDevice';

export const useActiveOtaPlan = (): OtaPlanDetails | undefined => {
    const { spotterId, spotterFamily } = useSpotterContext();
    const isSharedDevice = useIsSharedDevice();

    const isOwnDevice = !!spotterId && spotterFamily === 'mine' && !isSharedDevice;

    const { data: otaPlan } = useDeviceOtaDetail({ config: { enabled: isOwnDevice } });

    if (!isOwnDevice || !isOtaPlanActive(otaPlan)) {
        return undefined;
    }

    return otaPlan;
};
